import React from 'react'
import { withStyles } from 'material-ui/styles'
import styles from './styles'

const CustomLegend = (props) => {
  const { classes, selectedPairs, translate } = props;
  return (
    <div className={classes.legend}>
      {
        selectedPairs && selectedPairs.map((pair, key) => {
          if (pair.checked) {
            return (
              <span className={classes.legendItem} key={key} style={{
                color: pair.stroke
              }}>
                {(pair.value && pair.value.toLowerCase() === "limit") ? (
                  translate(pair.value.toLowerCase())
                ) : (pair.value)
                }

              </span>
            )
          }
          return null
        })
      }
    </div>
  )

}

export default withStyles(styles)(CustomLegend)
